import { render, staticRenderFns } from "./repairOrdersModal.vue?vue&type=template&id=2147cd53&scoped=true"
import script from "./repairOrdersModal.vue?vue&type=script&lang=js"
export * from "./repairOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./repairOrdersModal.vue?vue&type=style&index=0&id=2147cd53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147cd53",
  null
  
)

export default component.exports